import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const StockTanksNav = ({ title, desc, buttonLabel, buttonLink, imageUrl }) => {   
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    let textStrokeValue = "1px"; 
    if (screenWidth >= 768) {
        textStrokeValue = "3px"; 
    }
    if (screenWidth >= 1024) {
        textStrokeValue = "5px";
    }

    return (
        <div className="relative w-full h-screen overflow-hidden shadow-lg cursor-pointer brightness-75 hover:brightness-100 transition-all ease-in-out duration-150">
                 <img 
                    src={imageUrl} 
                    alt={title} 
                    className="w-full h-full object-cover" 
                />
            <div className="absolute inset-0 flex flex-col items-center justify-end bg-gradient-to-t from-black/50 via-black/0">
                <div className="p-40 text-white flex flex-col justify-center items-center">
                    <h2 className="font-customFont1 text-5xl font-black md:text-5xl lg:text-6xl transition-all duration-700 ease-in-out z-10" style={{WebkitTextStroke: textStrokeValue,textStroke: textStrokeValue}}>{title}</h2>
                    <h2 className="font-customFont2 text-xl font-bold md:text-3xl lg:text-4xl transition-all duration-700 ease-in-out z-10">{desc}</h2>
                    <Link to={buttonLink} className="relative border rounded-xl border-[#ffffff] text-[#ffffff] px-4 py-1 group overflow-hidden transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-[#ffffff] hover:text-[#13455a] z-10">
                        {buttonLabel}
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default StockTanksNav;